import classnames from 'classnames';
import React, { useState } from 'react';

import { LoginFooter, SigninForm } from 'components';

import loginImage from 'assets/loginImage.png';
import { Text } from 'components';

const  Login  = () => {
  const [isEmailFormShown, setIsEmailFormShown] = useState<boolean>(false);

  const loginText = [
    'Optimal satellite data collection at reasonable service fees',
    'Sign up for IOPS SPACE to use satellite data reception/transmission service'
  ];

  return (
    <div className="flex h-screen max-h-screen w-screen flex-col overflow-hidden bg-white">
      <main className="flex h-full w-full flex-1 items-center justify-center md:flex-row md:justify-between">
        <div className="flex h-full items-center justify-center md:flex-1">
          <SigninForm isEmailFormShown={isEmailFormShown} setIsEmailFormShown={setIsEmailFormShown} />
        </div>
        <div className={classnames('relative hidden h-full flex-1 md:block', { 'hidden md:hidden': isEmailFormShown })}>
          <div className="absolute h-full w-full">
            <div className="flex h-full flex-col items-center justify-center gap-3">
              {loginText.map((text) => (
                <Text key={text} color="white" size="heading2" weight="medium" className='text-center'>
                  {text}
                </Text>
              ))}
            </div>
          </div>
          <img className="h-full w-full object-cover" src={loginImage} alt="login satellite" />
        </div>
      </main>
      <LoginFooter />
    </div>
  );
};

export default Login;
